import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { FOCUS_COLOR } from 'src/theme-v2/focus';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  button: {
    justifyContent: 'center',
    display: 'flex',
    flex: 1,
    minHeight: 48,
    borderRadius: 100,
    backgroundColor: neutrals.white,
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      spreadRadius: 2,
      color: brand.main.variations['lighterWater-2'],
    }),
    borderColor: brand.main.water,
    borderWidth: 1,
  },
  buttonInner: {
    height: '100%',
    width: '100%',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: 8,
  },
  buttonHover: {
    backgroundColor: neutrals.neutralGrays.crystal,
    borderColor: brand.main.variations['darkerWater-1'],
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      spreadRadius: 2,
      color: brand.main.variations['lighterWater-2'],
    }),
  },
  buttonPressed: {
    backgroundColor: neutrals.neutralGrays.dust,
    borderColor: brand.main.variations['darkerWater-3'],
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      spreadRadius: 2,
      color: brand.main.variations['lighterWater-2'],
    }),
  },
  buttonFocus: {
    backgroundColor: neutrals.white,
    borderColor: FOCUS_COLOR,
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      spreadRadius: 2,
      color: brand.main.variations['lighterWater-1'],
    }),
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    backgroundColor: neutrals.white,
    borderColor: neutrals.neutralGrays.grey,
    ...getBoxShadow('none'),
  },
  text: { fontSize: 16, fontWeight: 700, lineHeight: 22, textAlign: 'center', color: brand.main.water },
  textHover: {
    color: brand.main.variations['darkerWater-1'],
  },
  textPressed: {
    color: brand.main.variations['darkerWater-3'],
  },
  textFocus: {
    color: brand.main.water,
  },
  textDisabled: {
    color: neutrals.neutralGrays.aluminium,
  },
});
